import { colors } from '@spaceshipapp/cambridge';
import Select from 'react-select';
import styled from 'styled-components';

export const CountrySelector = styled(Select)`
  font-size: 1rem;
  &:focus {
    background: red;
  }
  > div {
    border-radius: 0;
    &:focus {
      background: red;
    }
    > div {
      > span {
        display: none;
      }

      > div {
        > svg {
          color: ${colors.text};
        }
      }
    }
  }
`;
